module.exports = __webpack_public_path__ + "img/banner-19.8d241dbf.jpg";